/**
 * @flow
 */

/* eslint-disable */

'use strict';


/*::
import type { ReaderFragment } from 'relay-runtime';
export type DevelopmentImageBackground = "black" | "white";
export type DevelopmentImageCrop = "fill" | "fit";
export type DevelopmentImageSize = "full_page" | "half_page" | "quarter_page";
import type { FragmentReference } from "relay-runtime";
declare export opaque type DevelopmentSummary_development$ref: FragmentReference;
declare export opaque type DevelopmentSummary_development$fragmentType: DevelopmentSummary_development$ref;
export type DevelopmentSummary_development = {|
  +title: ?string,
  +deliveryDate: ?string,
  +slug: string,
  +developer: ?{|
    +name: ?string
  |},
  +broker: ?{|
    +organisation: ?{|
      +name: ?string
    |}
  |},
  +developmentImages: ?$ReadOnlyArray<{|
    +size: DevelopmentImageSize,
    +crop: DevelopmentImageCrop,
    +displayOnListing: boolean,
    +backgroundColor: DevelopmentImageBackground,
    +image: {|
      +url: string
    |},
  |}>,
  +aggregates: {|
    +productsCount: number,
    +activeProductsCount: number,
    +minSalePrice: number,
    +minNumberOfBedrooms: number,
    +maxNumberOfBedrooms: number,
    +postcode: ?string,
    +locality: ?string,
  |},
  +$refType: DevelopmentSummary_development$ref,
|};
export type DevelopmentSummary_development$data = DevelopmentSummary_development;
export type DevelopmentSummary_development$key = {
  +$data?: DevelopmentSummary_development$data,
  +$fragmentRefs: DevelopmentSummary_development$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DevelopmentSummary_development",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "deliveryDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Organisation",
      "kind": "LinkedField",
      "name": "developer",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "broker",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Organisation",
          "kind": "LinkedField",
          "name": "organisation",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentImage",
      "kind": "LinkedField",
      "name": "developmentImages",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "crop",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayOnListing",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "backgroundColor",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "Image",
          "kind": "LinkedField",
          "name": "image",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "url",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DevelopmentProductAggregates",
      "kind": "LinkedField",
      "name": "aggregates",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "productsCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeProductsCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minSalePrice",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "minNumberOfBedrooms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "maxNumberOfBedrooms",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "postcode",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "locality",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "DevelopmentProduct",
  "abstractKey": null
};
})();
// prettier-ignore
(node/*: any*/).hash = '27f454d42e480708e8a17204644acf1d';

export default node;
